import { FormControlLabel } from '@mui/material';

import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffCheckbox } from '@cast/shared-rff-ui';

import { Typography } from '@cast/design-system';

export const DeleteProtectionSection = () => {
  return (
    <InlineWithDescription
      description={
        <ControlWithDescription label="Delete protection">
          Prevents this edge node from being deleted by blocking autoscaler
          removals and delete requests while enabled.
        </ControlWithDescription>
      }
      controls={
        <FormControlLabel
          sx={{ gap: 8, ml: 0, alignSelf: 'flex-start' }}
          control={
            <RffCheckbox
              size="small"
              name="deleteProtection"
              testId="delete-protection-checkbox"
            />
          }
          label={<Typography variant="P12M">Delete protection</Typography>}
        />
      }
    />
  );
};
